import { useEffect, useState } from 'react';
import { ApiResponse, PortalChangePasswordRequest } from 'vopay';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function usePortalChangePassword() {
  const source = axios.CancelToken.source();
  const [pending, setPending] = useState(false);
  const [response, setResponse] = useState<ApiResponse | null>(null);

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function changePassword(params: PortalChangePasswordRequest) {
    try {
      setPending(true);
      const res = await api.postPortalChangePassword(params, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      setResponse(res);
      return res;
    } finally {
      setPending(false);
    }
  }

  return {
    pending,
    response,
    changePassword,
  };
}
